import { Navbar } from './Navbar';
import { Hero } from './Hero';
import { Features } from './Features';
import { Pricing } from './Pricing';
import { Footer } from './Footer';

export const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white font-inter">
      <Navbar />
      <Hero />
      <Features />
      <Pricing />
      <Footer />
    </div>
  );
};
